import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function ApiStyles() {
    return (
        <TopicLayout
            title="REST vs. GraphQL vs. gRPC"
            intro="Three different shapes for a client-service contract: one resource per endpoint, one flexible query language over a graph of data, or a typed, generated contract built for service-to-service calls."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={95} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>REST</text>
                    <Box x={55} y={25} width={80} height={30} label="Client"/>
                    <Box x={15} y={110} width={75} height={30} label="/users"/>
                    <Box x={105} y={110} width={75} height={30} label="/orders"/>
                    <Arrow x1={75} y1={55} x2={52} y2={110}/>
                    <Arrow x1={115} y1={55} x2={142} y2={110}/>
                    <text x={95} y={162} textAnchor="middle" fontSize={11} opacity={0.7}>separate call per resource</text>

                    <line x1={185} y1={10} x2={185} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={285} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>GraphQL</text>
                    <Box x={245} y={25} width={80} height={30} label="Client"/>
                    <Box x={230} y={110} width={110} height={34} label="GraphQL" accent/>
                    <Arrow x1={285} y1={55} x2={285} y2={110} label="1 query"/>
                    <text x={285} y={162} textAnchor="middle" fontSize={11} opacity={0.7}>users + orders, one response</text>

                    <line x1={375} y1={10} x2={375} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={475} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>gRPC</text>
                    <Box x={435} y={25} width={80} height={30} label="Client"/>
                    <Box x={435} y={110} width={80} height={34} label="Service" accent/>
                    <Arrow x1={455} y1={55} x2={455} y2={110} label="protobuf"/>
                    <Arrow x1={495} y1={110} x2={495} y2={55} muted/>
                    <text x={475} y={162} textAnchor="middle" fontSize={11} opacity={0.7}>typed, streaming-capable</text>
                </Diagram>
            }
            useWhen={[
                'REST: public or resource-oriented APIs that benefit from familiar HTTP tooling and caching.',
                'GraphQL: clients need different projections of connected data and over- or under-fetching is a demonstrated problem.',
                'gRPC: controlled service-to-service communication benefits from generated contracts, streaming or compact binary messages.'
            ]}
            tradeOff="REST can require multiple endpoints or calls for complex views. GraphQL offers client flexibility but needs query cost controls, authorization at field boundaries and a deliberate caching approach. gRPC is efficient and strongly typed but adds protobuf lifecycle and is less convenient for direct browser or third-party use."
            ruleOfThumb="Use REST as the external default, gRPC for controlled internal paths where its contract and performance help, and GraphQL when varied client data shapes justify its operational cost."
        />
    )
}
